import { Story } from "../view-models/story";

export const storiesMock = [
  new Story(
    8,
    "Планета забытых роботов",
    true,
    require("../shared/images/mocks/1.png"),
    1
  ),
  new Story(
    11,
    "Школа волшебных профессий",
    true,
    require("../shared/images/mocks/2.png"),
    1
  ),
  new Story(
    12,
    "Загадочная паутина",
    true,
    require("../shared/images/mocks/3.png"),
    1
  ),
  new Story(
    13,
    "Кроличья нора",
    true,
    require("../shared/images/mocks/4.png"),
    1
  ),
  new Story(
    14,
    "Дракон, который боялся летать",
    true,
    require("../shared/images/mocks/5.png"),
    1
  ),
  new Story(
    15,
    "Снежный великан",
    true,
    require("../shared/images/mocks/6.png"),
    1
  ),
  new Story(
    16,
    "Космическое королевство",
    true,
    require("../shared/images/mocks/7.png"),
    1
  ),
  new Story(
    17,
    "Машина времени",
    true,
    require("../shared/images/mocks/8.png"),
    1
  ),
  new Story(
    18,
    "Подводный город",
    true,
    require("../shared/images/mocks/9.png"),
    1
  ),
  new Story(
    19,
    "Хранитель снов",
    true,
    require("../shared/images/mocks/10.png"),
    1
  ),
  new Story(
    20,
    "Сапоги смелости",
    true,
    require("../shared/images/mocks/11.png"),
    1
  ),
  new Story(
    21,
    "Зеркало правды",
    true,
    require("../shared/images/mocks/12.png"),
    1
  ),
  
];
